import { render } from "./follow.vue?vue&type=template&id=06b8f74c"
import script from "./follow.vue?vue&type=script&lang=js"
export * from "./follow.vue?vue&type=script&lang=js"

import "./follow.vue?vue&type=style&index=0&id=06b8f74c&lang=postcss"
script.render = render

export default script